import {ATC_STATISTICS_FETCH_SUCCESSFULLY, DRUGS_PER_ATC_FETCH_SUCCESSFULLY} from "../actions/actionTypes";

const drugStatisticsReducer = (state = {}, action) => {
    switch (action.type) {
        case ATC_STATISTICS_FETCH_SUCCESSFULLY:
            return {
                ...state,
                atcCountriesCount: action.payload
            };
        case DRUGS_PER_ATC_FETCH_SUCCESSFULLY:
            return {
                ...state,
                drugsPerATC: action.payload
            };
        default:
            return state;
    }
};

export default drugStatisticsReducer;
